import { useNavigate } from 'react-router-dom';
import { mediaAsset } from '../../utils/media';
const LOGO = '/optimized-media/assets/logo_NTP-160.webp';
import { KAILASH_MAIN_ID } from '../../pages/explore/data';
import { useTours } from '../../context/TourContext';
import { tourPath } from '../../utils/tourUrls';
import styles from './footer.module.scss';
const WHATSAPP = mediaAsset('assets/Whatsapp.svg');
const YOUTUBE = mediaAsset('assets/youtube.svg');
//  main footer
const LowerBody = () => {
  return (
    <div className={styles.lower__body}>
      <Introduction />
      <QuickLinks />
    </div>
  );
};

//  logo div
const Introduction = () => {
  return (
    <div className={styles.introduction}>
      <div className={styles.logo}>
        <img src={LOGO} alt='NTP Tourism' width='160' height='160' loading='lazy' decoding='async' />
      </div>
      <div className={`${styles.description} text-justify relative z-1`}>
        Nepal-based planning for pilgrimage, cultural and Himalayan routes.
        We confirm dates, operating conditions and the final quotation in writing
        before a trip is treated as booked.
      </div>
      <div className={styles.social__links}>
        <div
          className={`cursor-pointer ${styles.facebook}`}
          onClick={() =>
            window.open(
              'https://facebook.com/ntpnepaltourism'
            )
          }
        >
          <svg
            width='25'
            height='25'
            viewBox='0 0 25 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M22.5 12.4062C22.5 6.88625 18.02 2.40625 12.5 2.40625C6.98 2.40625 2.5 6.88625 2.5 12.4062C2.5 17.2463 5.94 21.2762 10.5 22.2062V15.4062H8.5V12.4062H10.5V9.90625C10.5 7.97625 12.07 6.40625 14 6.40625H16.5V9.40625H14.5C13.95 9.40625 13.5 9.85625 13.5 10.4062V12.4062H16.5V15.4062H13.5V22.3563C18.55 21.8563 22.5 17.5963 22.5 12.4062Z'
              fill='var(--color-primary)'
            />
          </svg>
        </div>
        <div
          className={`cursor-pointer ${styles.instagram}`}
          onClick={() =>
            window.open('https://instagram.com/nepaltourismntp')
          }
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='25'
            height='25'
            viewBox='0 0 25 25'
            fill='none'
          >
            <path
              d='M8.3 2.40625H16.7C19.9 2.40625 22.5 5.00625 22.5 8.20625V16.6063C22.5 18.1445 21.8889 19.6198 20.8012 20.7075C19.7135 21.7952 18.2383 22.4062 16.7 22.4062H8.3C5.1 22.4062 2.5 19.8063 2.5 16.6063V8.20625C2.5 6.66799 3.11107 5.19274 4.19878 4.10503C5.28649 3.01732 6.76174 2.40625 8.3 2.40625ZM8.1 4.40625C7.14522 4.40625 6.22955 4.78553 5.55442 5.46067C4.87928 6.1358 4.5 7.05147 4.5 8.00625V16.8062C4.5 18.7962 6.11 20.4062 8.1 20.4062H16.9C17.8548 20.4062 18.7705 20.027 19.4456 19.3518C20.1207 18.6767 20.5 17.761 20.5 16.8062V8.00625C20.5 6.01625 18.89 4.40625 16.9 4.40625H8.1ZM17.75 5.90625C18.0815 5.90625 18.3995 6.03795 18.6339 6.27237C18.8683 6.50679 19 6.82473 19 7.15625C19 7.48777 18.8683 7.80571 18.6339 8.04013C18.3995 8.27455 18.0815 8.40625 17.75 8.40625C17.4185 8.40625 17.1005 8.27455 16.8661 8.04013C16.6317 7.80571 16.5 7.48777 16.5 7.15625C16.5 6.82473 16.6317 6.50679 16.8661 6.27237C17.1005 6.03795 17.4185 5.90625 17.75 5.90625ZM12.5 7.40625C13.8261 7.40625 15.0979 7.93303 16.0355 8.87072C16.9732 9.8084 17.5 11.0802 17.5 12.4062C17.5 13.7323 16.9732 15.0041 16.0355 15.9418C15.0979 16.8795 13.8261 17.4062 12.5 17.4062C11.1739 17.4062 9.90215 16.8795 8.96447 15.9418C8.02678 15.0041 7.5 13.7323 7.5 12.4062C7.5 11.0802 8.02678 9.8084 8.96447 8.87072C9.90215 7.93303 11.1739 7.40625 12.5 7.40625ZM12.5 9.40625C11.7044 9.40625 10.9413 9.72232 10.3787 10.2849C9.81607 10.8475 9.5 11.6106 9.5 12.4062C9.5 13.2019 9.81607 13.965 10.3787 14.5276C10.9413 15.0902 11.7044 15.4062 12.5 15.4062C13.2956 15.4062 14.0587 15.0902 14.6213 14.5276C15.1839 13.965 15.5 13.2019 15.5 12.4062C15.5 11.6106 15.1839 10.8475 14.6213 10.2849C14.0587 9.72232 13.2956 9.40625 12.5 9.40625Z'
              fill='var(--color-primary)'
            />
          </svg>{' '}
        </div>

        <div
          className={`cursor-pointer ${styles.whatsapp}`}
          onClick={() => window.open('https://wa.me/9779851054995')}
        >
          <img
            src={WHATSAPP}
            alt='WhatsApp'
            width='36'
            height='36'
            style={{ width: '22px', height: '22px' }}
          />
        </div>
        <div
          className={`cursor-pointer ${styles.youtube}`}
          onClick={() =>
            window.open('https://youtube.com/channel/UCDxRTZ0l7gHLDF8qYdirVig')
          }
        >
          <img
            src={YOUTUBE}
            alt='YouTube'
            width='36'
            height='25'
            style={{ width: '28px', height: 'auto' }}
          />
        </div>
        <div
          className={`cursor-pointer ${styles.viber}`}
          onClick={() => window.open('https://msng.link/o/?9851054995=vi')}
        >
          <span style={{ fontSize: '13px', fontWeight: 'bold', color: 'var(--color-primary)' }}>Viber</span>
        </div>
      </div>
    </div>
  );
};

//  links div
const QuickLinks = () => {
  const navigate = useNavigate();
  const { tours: ExploreContent } = useTours();
  const topTours = [
    ...ExploreContent.filter((item) => item.id === KAILASH_MAIN_ID),
    ...ExploreContent.filter((item) => item.id !== KAILASH_MAIN_ID),
  ].slice(0, 5);

  return (
    <div className={styles.quick__links}>
      <div className={styles.quick__links__block}>
        <div className={styles.title}>Top Tours</div>
{topTours.map((item) => (
    <div
      key={item.id}
      className={styles.item}
      onClick={() => navigate(tourPath(item))}
    >
      {item.title}
    </div>
  ))}
        <a
          href="/discover"
          className={styles.exploreBtn}
        >
          Explore More
        </a>
      </div>

      <div className={styles.quick__links__block}>
        <div className={styles.title}>Contact Us</div>
        <div className={styles.item} style={{ cursor: 'default' }}>
          Nepal Tourism Package Pvt. Ltd.
        </div>
        <div className={styles.item} style={{ cursor: 'default' }}>
          Jhamsikhel 03, Lalitpur, Nepal
        </div>
        <div className={styles.item}>
          <a href="tel:+9779851054995" style={{ color: 'inherit', textDecoration: 'none' }}>
            +977 9851054995
          </a>
          ,{' '}
          <a href="tel:+9779841356132" style={{ color: 'inherit', textDecoration: 'none' }}>
            +977 9841356132
          </a>
        </div>
        <div className={styles.item}>
          USA: <a href="tel:+19293069057" style={{ color: 'inherit', textDecoration: 'none' }}>+1 (929) 306-9057</a>
        </div>
        <div className={styles.item}>
          Landline: <a href="tel:+97715452848" style={{ color: 'inherit', textDecoration: 'none' }}>+977-1-5452848</a>
        </div>
        <div className={styles.item}>
          <a href="mailto:info@ntptourism.com" style={{ color: 'inherit', textDecoration: 'none' }}>
            info@ntptourism.com
          </a>
        </div>
      </div>
      <div className={styles.quick__links__block}>
        <div className={` ${styles.title}`}>Quick Links</div>
        <a href="/explore" className={styles.item}>All tour packages</a>
        {/* <a href="/blogs" className={styles.item}>Travel guides</a>
        <a href="/departure" className={styles.item}>Departure dates</a>
        <a href="/discover" className={styles.item}>Discover</a>
        <a href="/gallery" className={styles.item}>Gallery</a> */}
        <a href="/contact" className={styles.item}>Contact</a>
        <div
          className={` ${styles.item}`}
          onClick={() => {
            const { hash } = window.location;
            if (hash && hash === '#our-story') {
              document.getElementById('story-id').scrollIntoView({
                behavior: 'smooth',
              });
            } else {
              navigate('/about#our-story');
            }
          }}
        >
          Our Story
        </div>
        <div
          className={` ${styles.item}`}
          onClick={() => {
            navigate('/privacy');
          }}
        >
          Privacy Policy
        </div>
        <div
          onClick={() => {
            navigate('/terms-condition');
          }}
          className={` ${styles.item}`}
        >
          Terms & Conditions
        </div>

        <div
          className={styles.item}
          onClick={() => {
            navigate('/terms-condition#prices-and-payment');
          }}
        >
          Payment
        </div>
      </div>
    </div>
  );
};
export default LowerBody;
